import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if (window) {
      window.console.log = function(){};
    }
}

bootstrapApplication(AppComponent, appConfig).catch((error) => {
  // eslint-disable-next-line no-console
  console.error(error);
});